module.exports = __webpack_public_path__ + "img/profile-picture.907f5a93.png";